module.exports = __webpack_public_path__ + "assets/img/jyz.f1c5ecc1.png";